import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { omitTopLevelId } from '#/api/adapters/patchBody';

/**
 * PATCH supplier：含 updatedAt 樂觀鎖；addresses／contacts 為 replace-all（原樣傳遞）。
 */
export async function updateSupplier(id, payload) {
  const { data: raw } = await request.patch(
    `/srm/supplier/${id}`,
    keysToSnake(omitTopLevelId(payload)),
  );
  return parseVer4DetailResponse(raw);
}
